import React from 'react'

import AudioPlayer from '@cfc/secondstep-audio'
import RatioWrapper from 'components/RatioWrapper'

import { AudioContentWrapper, AudioWrapper } from './component.styles'

const AudioComponent = props => {
  const { src } = props || {}

  const audio = src ? <AudioPlayer src={src} /> : null

  return (
    <AudioWrapper>
      <RatioWrapper>
        <AudioContentWrapper>{audio}</AudioContentWrapper>
      </RatioWrapper>
    </AudioWrapper>
  )
}

AudioComponent.propTypes = {}

export default AudioComponent
